(($) => {

	// Testimonials slider
	$('.testimonials-testimonials').slick({
		arrows: true,
		prevArrow: `<div class="testimonials-arrow prev icon-angle-left"></div>"`,
		nextArrow: `<div class="testimonials-arrow next icon-angle-right"></div>"`,
		slidesToShow: 1,
		infinite: false
	});

	// Keep track of which slide is active
	const setActiveClass = ( currentSlide=0, $logoControls ) => {
		$logoControls = $logoControls || $('.testimonials-logoControl');

		$logoControls
			.removeClass('active')
			.filter(`[data-slide="${currentSlide}"]`)
			.addClass('active')
	};

	setActiveClass();

	$('.testimonials-testimonials').on( 'beforeChange', ( event, slick, currentSlide, nextSlide ) =>
		setActiveClass( nextSlide, $(event.target).parents('.testimonials').find('.testimonials-logoControl') )
	);

	$('.testimonials-logoControl').click( event => {
		const $logoControl = $(event.currentTarget);
		const $slideshow = $logoControl.parents('.testimonials').find('.testimonials-testimonials');
		const slide = parseInt( $logoControl.data('slide') );

		if( $slideshow ) {
			$slideshow.slick( 'slickGoTo', slide );
			setActiveClass( slide, $logoControl.parents('.testimonials').find('.testimonials-logoControl') );
		}
	});

})(jQuery);



// WEBPACK FOOTER //
// ../benetech/js/components/testimonials.js